
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as aboutCUD8SaMv6OgOJM0_45QXxQkEidAbWIk_457rp4US25wg09gMeta } from "/www/wwwroot/echopus.com/pages/about.vue?macro=true";
import { default as indexWcUvtEUuduMkxX3vzWgyLJFYnZeKq09Nx4fKwKBODB4Meta } from "/www/wwwroot/echopus.com/pages/index.vue?macro=true";
import { default as termsGXkwFtqA5K2uoCawCSqLQ_mD3GlbohZxM7UYZzrz4CwMeta } from "/www/wwwroot/echopus.com/pages/terms.vue?macro=true";
import { default as careersf4u5oo49oBnk2ucGkJwjplSx3_x61R7tSS5Rl6wQdlMMeta } from "/www/wwwroot/echopus.com/pages/careers.vue?macro=true";
import { default as contactxdWjTzcLuwTcTtgrSkqm0NUhcmN5VFwgsyNrIkg19aQMeta } from "/www/wwwroot/echopus.com/pages/contact.vue?macro=true";
import { default as privacy2mdr49rTIIFFled7yKrZVit6jhSPdnZNVEK29fBzGngMeta } from "/www/wwwroot/echopus.com/pages/privacy.vue?macro=true";
import { default as productsJB_rPNjFf5Zw4qK6EoB5TxKLoO2FqiCChMOFipHfY8YMeta } from "/www/wwwroot/echopus.com/pages/products.vue?macro=true";
import { default as projectstrXKl6A24Z7sj6waRQrdcpit7QtrzHNs2S4DqPvYt8oMeta } from "/www/wwwroot/echopus.com/pages/projects.vue?macro=true";
import { default as _91_46_46_46slug_9360aSzoePGbHLqK2bZrTFTC2AJisyD_wjJVJOF2QbUn8Meta } from "/www/wwwroot/echopus.com/pages/[...slug].vue?macro=true";
import { default as our_45story3H149PpEMGrUi_451ANwx1TjaWJ09ZmxxUSg5lUIpMd1sMeta } from "/www/wwwroot/echopus.com/pages/our-story.vue?macro=true";
import { default as component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8Meta } from "/www/wwwroot/echopus.com/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8 } from "/www/wwwroot/echopus.com/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/www/wwwroot/echopus.com/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/www/wwwroot/echopus.com/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/www/wwwroot/echopus.com/pages/terms.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/www/wwwroot/echopus.com/pages/careers.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/www/wwwroot/echopus.com/pages/contact.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/www/wwwroot/echopus.com/pages/privacy.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/www/wwwroot/echopus.com/pages/products.vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/www/wwwroot/echopus.com/pages/projects.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/www/wwwroot/echopus.com/pages/[...slug].vue")
  },
  {
    name: "our-story",
    path: "/our-story",
    component: () => import("/www/wwwroot/echopus.com/pages/our-story.vue")
  },
  {
    name: component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8Meta?.name,
    path: "/ar",
    component: component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8
  },
  {
    name: component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8Meta?.name,
    path: "/ar/:pathMatch(.*)",
    component: component_45stubi_4513Q3tbPPTOwzbX9Ich6Wf7bYvIF_45boBbvFWR9ulZ8
  }
]